import * as React from 'react';
import Avatar, { AvatarProps } from '@material-ui/core/Avatar';

export type DSAvatarProps = AvatarProps;

export const DSAvatar: React.FC<DSAvatarProps> = props => <Avatar {...props} />;
DSAvatar.displayName = 'DSAvatar';
